import { hasAnySubscriptionSelector } from '@repo/cf-user/selectors'
import { userQueryFetcher } from '@repo/cf-user/gen/user'
import { mapCurrencyToAvailableCurrencyCode } from '@repo/cf-user/hooks/use-user-data'
import type { CurrencyCode } from '@repo/graphql-types'
import type { PaymentsSubmitSubscriptionCheckoutMutationVariables } from '../gen/stripe'
import { isTeamSubscriptionType } from '../subscription-types'

interface SubscriptionCurrencyUser {
  stripeCustomer?: { currency?: { code?: CurrencyCode | null } | null } | null
  subscriptionAccess: Parameters<typeof hasAnySubscriptionSelector>[0]
}

export function getSubscriptionCreationCurrency(user: SubscriptionCurrencyUser | null | undefined) {
  return hasAnySubscriptionSelector(user?.subscriptionAccess)
    ? user?.stripeCustomer?.currency?.code
    : undefined
}

export async function withSubscriptionCreationCurrency(
  variables: PaymentsSubmitSubscriptionCheckoutMutationVariables,
): Promise<PaymentsSubmitSubscriptionCheckoutMutationVariables> {
  if (isTeamSubscriptionType(variables.input.subscriptionPlan)) {
    return variables
  }

  const data = await userQueryFetcher()().catch(() => undefined)
  const currency = getSubscriptionCreationCurrency(data?.me?.user)
  if (!currency) {
    return variables
  }

  return {
    ...variables,
    input: {
      ...variables.input,
      currencyCode: mapCurrencyToAvailableCurrencyCode(currency),
    },
  }
}
